import { CampaignDetailsForm } from "@/components/campaign/setup/CampaignDetailsForm";
import { Button } from "@/components/generic/Button";
import { PageHeaderProvider } from "@/providers/PageHeaderProvider";
import { useStepperSubmitHandlerState } from "@/utils/stepper";
import { createFileRoute } from "@tanstack/react-router";
import { useCallback, useMemo } from "react";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/details",
)({
  component: RouteComponent,
  staticData: {
    meta: {
      title: "Detaljer",
    },
  },
});

function RouteComponent() {
  const { user, useEditCampaign } = Route.useRouteContext();

  const { campaign, updateCampaign } = useEditCampaign();

  const campaignName = useMemo(() => campaign.name, [campaign.name]);
  const responsibleId = useMemo(
    () => campaign.responsibleId ?? user.id,
    [campaign.responsibleId, user.id],
  );

  const [submitHandler, setSubmitHandler] = useStepperSubmitHandlerState();

  return (
    <PageHeaderProvider
      options={{
        title: "Detaljer",
        actions: (
          <>
            <Button
              isDisabled={
                !submitHandler.isDirty ||
                submitHandler.isDisabled ||
                submitHandler.isPending
              }
              isPending={submitHandler.isPending}
              onPress={() => submitHandler.submit()}
            >
              Gem
            </Button>
          </>
        ),
      }}
    >
      <div className="flex h-full flex-col items-center justify-center">
        <CampaignDetailsForm
          values={useMemo(
            () => ({
              campaignName,
              responsibleId,
            }),
            [campaignName, responsibleId],
          )}
          onSubmit={useCallback(
            async (data) => {
              await updateCampaign({
                name: data.campaignName,
                responsibleId: data.responsibleId,
              });
            },
            [updateCampaign],
          )}
          setSubmitHandler={setSubmitHandler}
        />
      </div>
    </PageHeaderProvider>
  );
}
